import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { QueryProvider } from './context/QueryContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Calls from './pages/Calls';
import CallDetailPage from './pages/CallDetailPage';
import Analytics from './pages/Analytics';
import WorkflowManagementPage from './pages/WorkflowManagementPage';
import AssistantManagementPage from './pages/AssistantManagementPage';
import AgentManagementPage from './pages/AgentManagementPage';
import AdminPanel from './pages/AdminPanel';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import UserRoute from './components/UserRoute';
import AdminRoute from './components/AdminRoute';
import AdminLayout from './components/AdminLayout';

function App() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AuthProvider>
          <Router>
          <div className="App">
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#4ade80',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            
            {/* User routes - only accessible by regular users */}
            <Route element={<UserRoute />}>
              <Route path="/" element={<Layout><Dashboard /></Layout>} />
              <Route path="/calls" element={<Layout><Calls /></Layout>} />
              <Route path="/calls/:callId" element={<Layout><CallDetailPage /></Layout>} />
              <Route path="/analytics" element={<Layout><Analytics /></Layout>} />
              <Route path="/agents" element={<Layout><AgentManagementPage /></Layout>} />
              <Route path="/workflows" element={<Layout><WorkflowManagementPage /></Layout>} />
              <Route path="/assistants" element={<Layout><AssistantManagementPage /></Layout>} />
            </Route>
            
            {/* Admin routes - only accessible by admin users */}
            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<AdminLayout><AdminPanel /></AdminLayout>} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}

export default App;